<template>
  <div class="container-fluid position-relative">

    <div class="row">
      <div class="col-12 col-lg-8 col-xl-6 mt-3 mx-auto carouselProducts carouselContainer">
        <carousel :items=1 :nav="false" class="banner-formula-two-slider" @drag="dragFunction">
<!--          1 plus 800g-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/item1.png" alt="">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil1-plus" @click="readMore">Află mai multe</button>
              <button type="button" id="bt1" class="btn cumpara-prin" v-on:click="bt1">
                <img src="../../assets/images/pentru-imunitate/icon-buy.png" alt="Cumpără"> <span>Cumpără prin</span>
              </button>
            </div>
          </div>
<!--          2 plus 800g-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/item2.png" alt="">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil2-plus" @click="readMore">Află mai multe</button>
              <button type="button" id="bt2" class="btn cumpara-prin" v-on:click="bt2">
                <img src="../../assets/images/pentru-imunitate/icon-buy.png" alt="Cumpără"> <span>Cumpără prin</span>
              </button>
            </div>
          </div>
<!--          3 plus 800g-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/item3.png" alt="">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil3-plus" @click="readMore">Află mai multe</button>
              <button type="button" id="bt3" class="btn cumpara-prin" v-on:click="bt3">
                <img src="../../assets/images/pentru-imunitate/icon-buy.png" alt="Cumpără"> <span>Cumpără prin</span>
              </button>
            </div>
          </div>
<!--          1 plus 1200g-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/aptamil-1plus-1200g.png" alt="" style="margin-bottom: 45px;">
            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil1-plus-1200" @click="readMore">Află mai multe</button>
              <button type="button" id="bt4" class="btn cumpara-prin" v-on:click="bt4">
<!--                <img src="../../assets/images/pentru-imunitate/icon-buy.png" alt="Cumpără"> <span>Cumpără prin</span>-->
<!--                <a href="https://www.aptanutricia.ro/nutribiotik-1an-1200">Află mai multe</a>-->
                În curând
              </button>
            </div>
          </div>
<!--          2plus 1200g-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/aptamil-2plus-1200g.png" alt="" style="margin-bottom: 45px;">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil2-plus-1200" @click="readMore">Află mai multe</button>
              <button type="button" id="bt5" class="btn cumpara-prin" v-on:click="bt5">
<!--                <img src="../../assets/images/pentru-imunitate/icon-buy.png" alt="Cumpără"> <span>Cumpără prin</span>-->
<!--                <a href="https://www.aptanutricia.ro/nutribiotik-2ani-1200">Află mai multe</a>-->
                În curând
              </button>
            </div>
          </div>
<!--          1 plus lichid-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/05941209023184_C1C1_s01_100017384.png" alt="" style="max-height: 100% !important; max-width: 450px !important;">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil1-plus-lichid" @click="readMore">Află mai multe</button>
              <button type="button" id="bt6" class="btn cumpara-prin" v-on:click="bt6">
<!--                <a href="https://www.aptanutricia.ro/aptamil-nutribiotik-lichid-1an">Află mai multe</a>-->
                În curând
              </button>
            </div>
          </div>
<!--          2 plus lichid-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/05941209023207_C1C1_s15_100017387.png" alt="" style="max-height: 100% !important; max-width: 450px !important;">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil2-plus-lichid" @click="readMore">Află mai multe</button>
              <button type="button" id="bt7" class="btn cumpara-prin" v-on:click="bt7">
<!--                <a href="https://www.aptanutricia.ro/aptamil-nutribiotik-lichid-2ani">Află mai multe</a>-->
                În curând
              </button>
            </div>
          </div>
<!--          1 1200g-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/Aptamil_IF_1_1200g_062022_front_left-removebg-preview_1.png" alt="" style="margin-bottom: 50px;">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil1-1200" @click="readMore">Află mai multe</button>
              <button type="button" id="bt8" class="btn cumpara-prin" v-on:click="bt8">
<!--                <a href="https://www.aptanutricia.ro/nutribiotik-1-1200">Află mai multe</a>-->
                În curând
              </button>
            </div>
          </div>
<!--          2 1200g-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/Aptamil_FO_2_1200g_062022_front_left-removebg-preview_0.png" alt="" style="margin-bottom: 50px;">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil2-1200" @click="readMore">Află mai multe</button>
              <button type="button" id="bt9" class="btn cumpara-prin" v-on:click="bt9">
<!--                <a href="https://www.aptanutricia.ro/nutribiotik-2-1200">Află mai multe</a>-->
                În curând
              </button>
            </div>
          </div>
<!--          1 800g-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/item1_first.png" alt="">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil10" @click="readMore">Află mai multe</button>
              <button type="button" id="bt10" class="btn cumpara-prin" v-on:click="bt10">
                <img src="../../assets/images/pentru-imunitate/icon-buy.png" alt="Cumpără"> <span>Cumpără prin</span>
              </button>
            </div>
          </div>
<!--          2 800g-->
          <div class="d-block">
            <img class="img-fluid img-produs" src="../../assets/images/pentru-imunitate/item2_first.png" alt="">

            <div class="nav-buttons mt-3">
              <button type="button" class="btn btn-afla" data-toggle="modal" data-target="#aptamil2" @click="readMore">Află mai multe</button>
              <button type="button" id="bt11" class="btn cumpara-prin" v-on:click="bt11">
                <img src="../../assets/images/pentru-imunitate/icon-buy.png" alt="Cumpără"> <span>Cumpără prin</span>
              </button>
            </div>
          </div>
        </carousel>
      </div>
    </div>

    <div class="carouselOne">
      <aptamil-unu></aptamil-unu>
      <aptamil-doi></aptamil-doi>
      <aptamil-unu-plus></aptamil-unu-plus>
      <aptamil-doi-plus></aptamil-doi-plus>
      <aptamil-trei-plus></aptamil-trei-plus>
      <aptamil-unu-plus-big-pack></aptamil-unu-plus-big-pack>
      <aptamil-doi-plus-big-pack></aptamil-doi-plus-big-pack>
      <aptamil-unu-plus-lichid></aptamil-unu-plus-lichid>
      <aptamil-doi-plus-lichid></aptamil-doi-plus-lichid>
      <aptamil-unu-big-pack></aptamil-unu-big-pack>
      <aptamil-doi-big-pack></aptamil-doi-big-pack>
    </div>

  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
// import VueSlickCarousel from 'vue-slick-carousel'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// import Grasimi from "./modal1/grasimi";
import AptamilUnu from "./ModalAptamilUnu/Modal.vue"
import AptamilDoi from "./ModalAptamilDoi/Modal.vue"
import AptamilUnuPlus from "./ModalAptamilUnuPlus/Modal.vue"
import AptamilDoiPlus from "./ModalAptamilDoiPlus/Modal.vue"
import AptamilTreiPlus from "./ModalAptamilTreiPlus/Modal.vue"
import AptamilUnuPlusBigPack from "./ModalAptamilUnuPlusBigPack/Modal.vue"
import AptamilDoiPlusBigPack from "./ModalAptamilDoiPlusBigPack/Modal.vue"
import AptamilUnuPlusLichid from "./ModalAptamilUnuPlusLichid/Modal.vue"
import AptamilDoiPlusLichid from "./ModalAptamilDoiPlusLichid/Modal.vue"
import AptamilUnuBigPack from "./ModalAptamilUnuBigPack/Modal.vue"
import AptamilDoiBigPack from "./ModalAptamilDoiBigPack/Modal.vue"


export default {
  name: 'MyComponent',
  components: {
    'carousel': carousel,
    'aptamil-unu': AptamilUnu,
    'aptamil-doi': AptamilDoi,
    'aptamil-unu-plus': AptamilUnuPlus,
    'aptamil-doi-plus': AptamilDoiPlus,
    'aptamil-trei-plus': AptamilTreiPlus,
    'aptamil-unu-plus-big-pack': AptamilUnuPlusBigPack,
    'aptamil-doi-plus-big-pack': AptamilDoiPlusBigPack,
    'aptamil-unu-plus-lichid': AptamilUnuPlusLichid,
    'aptamil-doi-plus-lichid': AptamilDoiPlusLichid,
    'aptamil-unu-big-pack': AptamilUnuBigPack,
    'aptamil-doi-big-pack': AptamilDoiBigPack,
    // Grasimi,
    // VueSlickCarousel
  },
  data() {
    return {
      settings: {
        "arrow": false,
        "dots": true,
        // "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "responsive": [
          {
            "breakpoint": 992,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "arrow": false,
            }
          },
        ]
      }
    }
  },
  methods: {
    dragFunction() {
      document.getElementsByClassName('banner-formula-two-slider')[0].click();
    },

    readMore() {
        window.gtag('event', 'click', {'event_category': 'nutri-afla-mai-multe'});
    },
    bt1() {
      document.getElementById('bt1').classList.toggle('open');
      document.getElementById('buy1').classList.toggle('show-buy')
      var offsets = document.getElementById('bt1').getBoundingClientRect();
      document.getElementById('buy1').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy1').style.left = offsets.left + 'px';
    },
    bt2() {
      document.getElementById('bt2').classList.toggle('open');
      document.getElementById('buy2').classList.toggle('show-buy')
      var offsets = document.getElementById('bt2').getBoundingClientRect();
      document.getElementById('buy2').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy2').style.left = offsets.left + 'px';
    },
    bt3() {
      document.getElementById('bt3').classList.toggle('open');
      document.getElementById('buy3').classList.toggle('show-buy')
      var offsets = document.getElementById('bt3').getBoundingClientRect();
      document.getElementById('buy3').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy3').style.left = offsets.left + 'px';

    },
    bt4() {
      document.getElementById('bt4').classList.toggle('open');
      document.getElementById('buy4').classList.toggle('show-buy')
      var offsets = document.getElementById('bt4').getBoundingClientRect();
      document.getElementById('buy4').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy4').style.left = offsets.left + 'px';
    },
    bt5() {
      document.getElementById('bt5').classList.toggle('open');
      document.getElementById('buy5').classList.toggle('show-buy')
      var offsets = document.getElementById('bt5').getBoundingClientRect();
      document.getElementById('buy5').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy5').style.left = offsets.left + 'px';
    },
    bt6() {
      document.getElementById('bt6').classList.toggle('open');
      document.getElementById('buy6').classList.toggle('show-buy')
      var offsets = document.getElementById('bt6').getBoundingClientRect();
      document.getElementById('buy6').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy6').style.left = offsets.left + 'px';
    },
    bt7() {
      document.getElementById('bt7').classList.toggle('open');
      document.getElementById('buy7').classList.toggle('show-buy')
      var offsets = document.getElementById('bt7').getBoundingClientRect();
      document.getElementById('buy7').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy7').style.left = offsets.left + 'px';
    },
    bt8() {
      document.getElementById('bt8').classList.toggle('open');
      document.getElementById('buy8').classList.toggle('show-buy')
      var offsets = document.getElementById('bt8').getBoundingClientRect();
      document.getElementById('buy8').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy8').style.left = offsets.left + 'px';
    },
    bt9() {
      document.getElementById('bt9').classList.toggle('open');
      document.getElementById('buy9').classList.toggle('show-buy')
      var offsets = document.getElementById('bt9').getBoundingClientRect();
      document.getElementById('buy9').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy9').style.left = offsets.left + 'px';
    },
    bt10() {
      document.getElementById('bt10').classList.toggle('open');
      document.getElementById('buy10').classList.toggle('show-buy')
      var offsets = document.getElementById('bt10').getBoundingClientRect();
      document.getElementById('buy10').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy10').style.left = offsets.left + 'px';
    },
    bt11() {
      document.getElementById('bt11').classList.toggle('open');
      document.getElementById('buy11').classList.toggle('show-buy')
      var offsets = document.getElementById('bt11').getBoundingClientRect();
      document.getElementById('buy11').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy11').style.left = offsets.left + 'px';
    },
  },
}


</script>

<style lang="scss">
.carouselProducts {
  .owl-item {
    z-index: -1;
  }

  .owl-theme .owl-dots .owl-dot span {
    background-color: #fff !important;
  }

  .owl-dots {
    z-index: 20;
    position: absolute;
    left: 50%;
    bottom: 80px;
    transform: translateX(-50%);
  }
}

.nav-buttons {
  padding-top: 60px;
  position: relative;

  button {
    display: inline-block;
    margin: 0 15px;

    &.cumpara-prin,
    &.btn-afla {
      padding: .375rem 2.5rem;
      font-weight: 400;

      width: 235px;

      img,
      span {
        pointer-events: none;
      }
    }

    &.btn-afla {
      color: #001388;
      max-width: unset;
      border-color: #001388;
    }

    &.cumpara-prin {
      background-color: #001388;

      span {
        line-height: 40px;
      }

      img {
        display: inline-block;
        width: auto !important;
        max-height: 100% !important;
        margin-right: 15px;
        margin-top: -5px;
      }
    }
  }
}

.height-row {
  min-height: 40px;
  margin: 0 !important;
  cursor: pointer;
}

.dropdown-menu {
  font-weight: 400;
  line-height: 1.5;
  float: left;
  min-width: 10rem;
  margin: .125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  padding: 15px 20px 20px;
  right: auto;
  bottom: auto;
  z-index: 9;
  width: 235px;
  border-radius: 0 0 30px 30px;
  border: none;
  box-shadow: 0 0 20px 0 rgba(145, 145, 145, 0.2);
  height: auto;
  position: absolute;
  transform: translate3d(0px, 50px, 0px);
  top: 495px;
  left: 46px;
  flex-direction: column;
  justify-content: center;
}

.border-table {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  height: inherit;
  display: flex;
  align-items: center;
}


.border-table.border-last {
  border-right: 0;
}

.hide-buy {
  display: none;
}

.show-buy {
  display: flex;
}

.open {
  border-radius: 20px 20px 0 0 !important;
}

.border-table .span-blue {
  font-size: 12px;
  color: #17479E;
  font-weight: 500;
  padding-left: 30px;
  text-align: left;
}

.border-table .span-black {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  padding-left: 30px;
  text-align: left;
}

.tab-content {
  margin-top: 50px;
}

.tab-content .box-shadow {

  -webkit-box-shadow: 0 -1px 20px 0 rgba(0, 0, 0, 0.24);
  -moz-box-shadow: 0 -1px 20px 0 rgba(0, 0, 0, 0.24);
  box-shadow: 0 -1px 20px 0 rgba(0, 0, 0, 0.24);
  border: 1px solid #fff;
  border-radius: 25px;
}

.modal-header {
  border-bottom: none;

  .close {
    float: right;
    font-size: 60px;
    font-weight: 400;
    line-height: 1;
    color: #17479E;
    opacity: 1;
  }
}

.modal-body {
  margin-top: -35px;
  padding-bottom: 70px;
}

.custom-arrow-left {
  width: 67px;
  height: 67px;
  font-size: 0;
  line-height: 0;
  position: absolute;
  z-index: 9;
  top: 50%;
  display: block;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  border: none;
  outline: none;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: 62%;
}

.custom-arrow-left.slick-prev {
  left: -200px;
}

.custom-arrow-left:before {
  content: url("../../assets/images/formule-aptamil/arrow-left.png");
  width: 11px;
  height: 20px;
  opacity: 1;
  position: absolute;
  top: 22px;
  left: 25px;

}

.custom-arrow-right {
  width: 67px;
  height: 67px;
  font-size: 0;
  line-height: 0;
  position: absolute;
  top: 50%;
  display: block;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  border: none;
  outline: none;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: 62%;
}

.custom-arrow-right:before {
  content: url("../../assets/images/formule-aptamil/arrow-right.png");
  width: 11px;
  height: 20px;
  position: absolute;
  top: 22px;
  right: 25px;
}

.custom-arrow-right.slick-next {
  right: -200px;
}

.plus {
  font-size: 14px;
  color: white;
  background-color: #C4E4F9;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}

.minus {
  font-size: 14px;
  color: white;
  background-color: #333333;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}

.border-table .minus,
.border-table .plus {
  margin-right: 15px;
}

.slick-slide img {
  display: block;
}

.star-rating-container {
  margin-top: 15px;
  min-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.star-rating.star-rating-sm {
  height: 20px;
  line-height: 20px;
  font-size: 24px;
}

.star-rating {
  display: inline-block;
  position: relative;
  white-space: nowrap;
  vertical-align: top;
  height: 32px;
  line-height: 32px;
  font-size: 26px;
  color: #ccc;
  letter-spacing: 2px;
}

.star-rating:before {
  position: relative;
  content: "\2605\2605\2605\2605\2605";
  display: inline-block;
}

.star-rating .star-rating-inner {
  white-space: nowrap;
  position: absolute;
  line-height: inherit;
  height: inherit;
  top: 0;
  left: 0;
  z-index: 1;
  overflow: hidden;
}

.star-rating-read .star-rating-inner:before {
  position: relative;
  content: "\2605\2605\2605\2605\2605";
  color: #f9bf3b;
}

.star-rating-container span {
  line-height: 20px;
  font-size: 14px;
  color: #17479E;
  margin-left: 5px;
}

@media only screen and (max-width: 992px) {
  .custom-arrow-left.slick-prev {
    left: 0;
    width: 40px;
    height: 40px;
    top: 40%;
  }

  .custom-arrow-right.slick-next {
    right: 0;
    width: 40px;
    height: 40px;
    top: 40%;
  }
  .custom-arrow-right:before {
    top: 11px;
    right: 14px;
  }
  .custom-arrow-left:before {
    top: 11px;
    left: 13px;
  }
  .modal-content .nav-tabs {
    justify-content: space-between;
  }
  .nav-tabs {
    display: table;
    margin: auto;
    border-bottom: 1px solid #DDDDDD;
    padding: 0;
    margin-top: 40px;
    margin-bottom: 30px;
    width: 700px;
  }
  .nav-tabs .nav-item {
    margin-bottom: -1px;
    display: inline-block;
    cursor: pointer;
    font-size: 14px;
  }
  .scroll-vertical-band {
    overflow-x: scroll;
  }
  .tab-content .box-shadow {
    width: 700px;
    margin: 0 auto;
  }
  .tab-content {
    overflow-x: scroll;
    padding: 30px 0px;
    margin-top: 0px;
  }

}

@media only screen and (max-width: 768px) {
  .nav-buttons {
    padding-top: 40px;

    button {
      margin: 15px auto;
      display: block;
    }
  }

  .carouselProducts {
    .owl-dots {
      bottom: 160px;
    }
  }

  .star-rating-container {
    display: flex;
    flex-direction: column;
  }

}

@media only screen and(max-width: 526px) {
  .dropdown-menu {
    //top: 282px !important;
    width: 235px;
    //left: 15px !important;
    padding: 20px;
  }
}
</style>
